import dotProp from 'dot-prop-immutable'

export default function(container) {
  let pathname = dotProp.get(container, 'location.pathname', '')
  if (pathname.substr(0, 1) === '/') {
    pathname = pathname.substr(1)
  }

  return pathname.replace('/', '-')
}



// WEBPACK FOOTER //
// ./src/utils/slugFromUrl.js